import { render, staticRenderFns } from "./OverPassPlugin.vue?vue&type=template&id=533f8de0&scoped=true"
import script from "./OverPassPlugin.vue?vue&type=script&lang=ts"
export * from "./OverPassPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./OverPassPlugin.vue?vue&type=style&index=0&id=533f8de0&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "533f8de0",
  null
  ,true
)

export default component.exports